import { render, staticRenderFns } from "./NotesOverlay.vue?vue&type=template&id=fd3f1cea&scoped=true&"
import script from "./NotesOverlay.vue?vue&type=script&lang=js&"
export * from "./NotesOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NotesOverlay.vue?vue&type=style&index=0&id=fd3f1cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3f1cea",
  null
  
)

export default component.exports